import { GESTION_OPERATIVA_CLEAR_GO } from './constants'
import initialState from './initialState'

export function clearGestionOperativa() {
  return (dispatch)=>{
    dispatch({
      type: GESTION_OPERATIVA_CLEAR_GO,
    })
    
  }
}

export function reducer(state, action) {
  if (action.type === GESTION_OPERATIVA_CLEAR_GO) {
      return {
        ...initialState,
      }
  }
  else{
      return state
  }
}
